import React from 'react';

import { Radio, withStyles, RadioProps } from '@material-ui/core';

export const NASSRadio = withStyles((theme) => ({
  root: {
    color: '#C5BE8B',
  },
}))((props: RadioProps) => <Radio {...props} />);
